import camelcaseKeys from 'camelcase-keys'
import { getTextValue } from '@/lib/helpers/LocalizedText'
import { getFileURL } from '@/lib/helpers/FileURLGetter'
export class CatalogWithCategoriesAndProducts {
  constructor (params = {}) {
    const { catalog, categories, products } = params ? camelcaseKeys(params) : {}
    this.catalog = new Catalog(catalog)
    this.categories = categories ? categories.map((item) => {
      return {
        category: new Category(item.category),
        products: item.products ? item.products.map((item) => {
          return {
            product: new Product(item),
            tax: new Tax(item.tax),
          }
        }) : [],
      }
    }) : []
    this.products = products ? products.map((item) => {
      return {
        product: new Product(item),
        tax: new Tax(item.tax),
      }
    }) : []
  }
}
export class Catalog {
  constructor (params = {}) {
    const { id, name } = params ? camelcaseKeys(params) : {}
    this.id = id
    this.name = name || null
  }
}
export class Category {
  constructor (params = {}) {
    const { id, name, description, shortDescription, catalogId, active, coverImageId } = params ? camelcaseKeys(params) : {}
    this.id = id
    this.name = name ? getTextValue(name) : null
    this.description = description ? getTextValue(description) : null
    this.shortDescription = shortDescription ? getTextValue(shortDescription) : null
    this.catalogId = catalogId
    this.active = active || false
    this.coverImageUrl = coverImageId ? getFileURL(coverImageId) : null
  }
}
export class Product {
  constructor (params = {}) {
    const { id, name, description, shortDescription, taxId, catalogId, categoryId, outOfStock, relatedProductIds, pricingGroupsWithPrices, active, coverImageId, modifiers, type } = params ? camelcaseKeys(params, { deep: true }) : {}
    this.id = id
    this.taxId = taxId || null
    this.active = active || false
    this.catalogId = catalogId || null
    this.categoryId = categoryId || null
    this.outOfStock = outOfStock || null
    this.name = name ? getTextValue(name) : null
    this.relatedProductIds = relatedProductIds || []
    this.modifiers = modifiers.map(item => new ProductModifier(item))
    this.description = description ? getTextValue(description) : null
    this.coverImageUrl = coverImageId ? getFileURL(coverImageId) : null
    this.shortDescription = shortDescription ? getTextValue(shortDescription) : null
    this.pricingGroupsWithPrices = pricingGroupsWithPrices ? pricingGroupsWithPrices.map((item) => new PricingGroupWithPrices(item)) : []
    this.displayedModifiers = this.modifiers.filter((modifier) => modifier.options.length)
    this.serviceCharge = type ? (type.serviceCharge ? type.serviceCharge : null) : null
    this.taxes = type ? (type.taxes ? type.taxes : null) : null
  }
}
export class Tax {
  constructor (params = {}) {
    const { id, name, value, inclusive } = params ? camelcaseKeys(params) : {}
    this.id = id
    this.name = name || null
    this.value = value || null
    this.inclusive = inclusive || false
  }
}
export class PricingGroupWithPrices {
  constructor (params = {}) {
    const { pricingGroupId, prices } = params ? camelcaseKeys(params) : {}
    this.pricingGroupId = pricingGroupId
    this.prices = prices.map((item) => {
      const { priceItems } = item ? camelcaseKeys(item) : {}
      var array = priceItems
        ? priceItems.map((price) => new Price(price))
        : Array.isArray(item)
          ? item.map((price) => new Price(price))
          : []
      return array
    })
  }
}
export class Price {
  constructor (params = {}) {
    const { amount, currency } = params ? camelcaseKeys(params) : {}
    this.amount = amount
    this.currency = currency
  }
}

class ProductModifier {
  constructor (params = {}) {
    const { id, name, callToAction, minSelected, maxSelected, catalogProductId, modifiersOptions, order } = params ? camelcaseKeys(params, { deep: true }) : {}
    this.id = id
    this.name = name ? getTextValue(name) : null
    this.catalogProductId = catalogProductId || null
    this.callToAction = callToAction ? getTextValue(callToAction) : null
    this.minSelected = typeof minSelected === 'number' ? minSelected : null
    this.maxSelected = typeof maxSelected === 'number' ? maxSelected : null
    this.options = modifiersOptions.map(item => new ProductModifierOption(item))
    this.order = typeof order === 'number' ? order : null
  }
}

class ProductModifierOption {
  constructor (params = {}) {
    const { id, name, price, order } = params ? camelcaseKeys(params, { deep: true }) : {}
    this.id = id
    this.name = name ? getTextValue(name) : null
    this.price = price.map(item => new PricingGroupWithPrices(item))
    this.order = typeof order === 'number' ? order : null
  }
}
